export default "__VITE_ASSET__Cvji4zmI__"